// extracted by mini-css-extract-plugin
module.exports = {"user-avatar__container":"UserAvatar_user-avatar__container__iO_Q7","user-avatar__indicator":"UserAvatar_user-avatar__indicator__eLM61"};